import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../store';
import { InvoiceDisplay } from './models/Invoice.interface';
import { Billing, ListInvoicesOutput } from "@smash-sdk/billing";
import { AsyncState } from '../../shared/models/async.interface';
import { Plan } from '../planUpgrade/models/Plan.interface';

export interface InvoiceState extends AsyncState {
    invoices: InvoiceDisplay[]
}

const formatInvoices = ({ invoices }: ListInvoicesOutput): InvoiceDisplay[] => {
    const formatedInvoices = invoices.map(invoice => {
        const { id, vat, url, date, status, created, priceExclTax, refundInvoice, plan } = invoice;
        return {
            id,
            vat,
            url,
            date,
            status,
            created,
            price: priceExclTax,
            currency: plan.currency as Plan['currency'],
            refundInvoice,
            plan: plan.name,
        }
    });
    return formatedInvoices;
}

export const listInvoice = createAsyncThunk(
    'invoice/listInvoice',
    async (_, thunkApi) => {
        try {
            const billing = new Billing();
            const response = await billing.listInvoices();
            const formatedInvoices = formatInvoices(response);
            return { invoices: formatedInvoices };
        } catch (error: any) {
            return thunkApi.rejectWithValue({ ...error });
        }
    }
)


export const initialState: InvoiceState = {
    invoices: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: undefined,
}

export const invoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        resetInvoice: (state) => ({
            invoices: [],
            isLoading: false,
            isSuccess: false,
            isError: false,
            error: undefined,
        }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(listInvoice.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.isError = false;
                state.error = undefined;
            })
            .addCase(listInvoice.fulfilled, (state, action) => {
                state.isSuccess = true;
                state.isLoading = false;
                state.invoices = action.payload.invoices;
            })
            .addCase(listInvoice.rejected, (state, action) => {
                state.isSuccess = false;
                state.isLoading = false;
                state.isError = true;
                state.invoices = initialState.invoices;
                state.error = action.error;
            })
    }
});


export const { resetInvoice } = invoiceSlice.actions;
export const invoiceState = (state: RootState) => state.invoice;

export default invoiceSlice.reducer;